import {getNews} from "../../news/api/NewsApi.js";
import * as UIUtil from "../../util/UI.js";
import * as _Notice from "../../notice/panel/Notice.js";
import * as _News from "./News.js";

export const open = async function (newsId, pushHistory = true) {
    try {
        // 히스토리에 상태 추가 (뒤로가기 지원)
        if (pushHistory) {
            const currentHash = location.hash.substring(1);
            const currentState = history.state;

            // 현재 상태가 News 메뉴이거나 다른 newsId인 경우에만 히스토리 추가
            if (!currentState?.newsId || currentState.newsId !== newsId) {
                history.pushState({ menuKey: 'News', newsId }, '', `#News/${newsId}`);
            }
        }

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/prcenter/보도자료-상세보기.html`;

        const headerWrap = document.querySelector(".headerWrap");
        if (!headerWrap) {
            console.error('[NewsDetail] headerWrap not found');
            UIUtil.msgBox("페이지 로딩 실패", "error");
            return;
        }

        console.log('[NewsDetail] Removing existing elements');
        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const response = await fetch(htmlUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const html = await response.text();

        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        const bannerEl = wrapper.querySelector(".banner");
        const contentEl = wrapper.querySelector("section.contents-wrap");


        if (bannerEl) {
            headerWrap.insertAdjacentElement("afterend", bannerEl);
            if (contentEl) bannerEl.insertAdjacentElement("afterend", contentEl);
        } else {
            if (contentEl) headerWrap.insertAdjacentElement("afterend", contentEl);
        }

        const result = await getNews(newsId);
        if (!result || !result.SUCCESS) {
            UIUtil.msgBox("보도자료 조회 실패", "error");
            return;
        }

        renderNews(result.RESULT);
        drawPrevNextLinks(result.RESULT);
        initEvent();


    } catch (error) {
        UIUtil.msgBox("보도자료 로딩 중 오류가 발생했습니다", "error");
    }
};
const renderNews = function (data) {
    // 제목, 날짜, 카테고리
    const categoryEl = document.querySelector(".board-view .tit-cnt span");
    const titleEl = document.querySelector(".board-view .tit-cnt h2");
    const dateEl = document.querySelector(".board-view .tit-cnt p");

    if (categoryEl) categoryEl.textContent = "보도자료";
    if (titleEl) titleEl.textContent = data.title || "";
    if (dateEl) dateEl.textContent = data.registerDate || "";

    // 본문
    const contentEl = document.querySelector(".board-view .news-content");
    if (contentEl) {
        contentEl.innerHTML = data.content || "";
        contentEl.style.display = "block";
    }

    // 대표 이미지
    const imgCntEl = document.querySelector(".board-view .img-cnt");
    if (imgCntEl) {
        imgCntEl.innerHTML = "";
        if (data.newsFiles && data.newsFiles.length > 0) {
            const img = document.createElement("img");
            img.src = `/news/file/view/${data.newsFiles[0].newsImgId}`;
            img.alt = data.newsFiles[0].fileName || "보도자료 이미지";
            img.style.width = "100%";
            img.style.height = "auto";
            imgCntEl.appendChild(img);
        }
    }

    // 기사 링크 리스트
    const originalEl = document.querySelector(".board-view .original");
    if (originalEl) {
        originalEl.innerHTML = "";

        if (data.articles && data.articles.length > 0) {
            const linksHtml = data.articles.map(article => {
                const url = article.articleUrl.startsWith('http')
                    ? article.articleUrl
                    : `https://${article.articleUrl}`;

                return `
                <a href="${url}" target="_blank">
                    <span>원문 기사 바로보기</span> ${article.articleTitle}
                </a>
            `;
            }).join("");

            originalEl.innerHTML = linksHtml;
        }
    }
};

const drawPrevNextLinks = function (data) {
    const prevNextEl = document.querySelector(".view-select-cnt");
    if (!prevNextEl) return;

    const prevEl = prevNextEl.querySelector(".prev");
    const nextEl = prevNextEl.querySelector(".next");

    addPrevNextLink(prevEl, data.previousId, data.previousTitle, 'prev');
    addPrevNextLink(nextEl, data.nextId, data.nextTitle, 'next');
};

const addPrevNextLink = function (containerEl, id, title, direction) {
    containerEl.innerHTML = "";
    containerEl.innerHTML = createPrevNextA(id, title, direction);

    if (id) {
        containerEl.querySelector("a")?.addEventListener("click", (e) => {
            e.preventDefault();
            open(id, true); // 상세 재호출 시 히스토리 추가
        });
    }
};

const createPrevNextA = function (id, title, direction) {
    const iconClass = direction === "prev" ? "i-prev" : "i-next";
    const lang = document.documentElement.lang || "ko";

    const label = direction === "prev"
        ? (lang === "en" ? "Previous" : "이전글")
        : (lang === "en" ? "Next" : "다음글");

    return `
        <a ${id ? `id="${id}" href="#"` : `href="javascript:void(0)"`}>
            <span>${label}<i class="${iconClass}"></i></span>
            <p>${title}</p>
        </a>
    `;
};
const initEvent = function () {
    const backBtn = document.querySelector(".btn-wrap .btn-large");

    if (!backBtn) {
        console.warn('[NewsDetail] Back button not found');
        return;
    }

    backBtn.addEventListener("click", function (e) {
        e.preventDefault();
        // 브라우저 히스토리를 사용하여 뒤로가기
        history.back();
    });
};